import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';
import Reveal from './Reveal';
import { aiForBusiness } from '../data/site';

const AiForBusiness = () => (
  <section id="ai-for-business" className="relative overflow-hidden border-t border-ink-700 py-24">
    <div className="pointer-events-none absolute -right-40 top-10 h-96 w-96 rounded-full bg-signal-500/10 blur-3xl" />
    <div className="container-site relative">
      <div className="grid gap-14 lg:grid-cols-[1fr_1.2fr]">
        <Reveal>
          <p className="eyebrow">AI for small &amp; medium businesses</p>
          <h2 className="mt-4 font-display text-3xl font-bold text-white md:text-4xl">
            Put AI to work in the business you already run.
          </h2>
          <p className="mt-6 leading-relaxed text-slate-400">
            You don't need a data science team or a new system to benefit from AI. We help small and medium
            businesses in Moncton and across Atlantic Canada find where AI saves real time and money, then set it up inside the tools you already use,
            like email, documents, your CRM and your accounting software.
          </p>
          <p className="mt-4 leading-relaxed text-slate-400">
            We handle the whole process, from advice to a working setup, with plain-language guidance at every
            step.
          </p>
          <Link to="/contact?service=ai" className="btn-primary mt-8">
            Book an AI consultation <Icon name="arrow" className="h-4 w-4" />
          </Link>
        </Reveal>

        <Reveal delay={0.1} className="card p-6 sm:p-8">
          <h3 className="font-display text-lg font-semibold text-white">What businesses use it for</h3>
          <ul className="mt-6 grid gap-4 sm:grid-cols-2">
            {aiForBusiness.useCases.map((useCase) => (
              <li key={useCase} className="flex gap-3 text-sm leading-relaxed text-slate-300">
                <Icon name="check" className="mt-0.5 h-4 w-4 shrink-0 text-signal-400" />
                {useCase}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>

      <ol className="mt-16 grid gap-px overflow-hidden rounded-xl border border-ink-700 bg-ink-700 sm:grid-cols-2 lg:grid-cols-4">
        {aiForBusiness.steps.map((step, i) => (
          <Reveal as="li" key={step.title} delay={i * 0.08} className="bg-ink-950 p-6">
            <span className="font-mono text-xs text-signal-400">STEP 0{i + 1}</span>
            <h3 className="mt-3 font-display text-lg font-semibold text-white">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{step.text}</p>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);

export default AiForBusiness;
